// extracted by mini-css-extract-plugin
export default {"container":"components_container__L3LtN"};